var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Gov Feedback",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1000px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "applymentStatus"
    }
  }, [_c('div', {
    staticClass: "bgWrap"
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.applymentStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applymentStatus", $$v);
      },
      expression: "dataForm.applymentStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "ACRA_REJECTED"
    }
  }, [_vm._v("Rejected")]), _c('el-radio', {
    attrs: {
      "label": "FINISH"
    }
  }, [_vm._v("Pass")])], 1)], 1)])], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4,
      "autosize": {
        minRows: 3
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _vm.dataForm.applymentStatus == 'ACRA_REJECTED' ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attachments",
      "prop": "attachmentUrls"
    }
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.attachmentUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attachmentUrls", $$v);
      },
      expression: "dataForm.attachmentUrls"
    }
  })], 1)], 1)] : _vm._e(), _vm.dataForm.applymentStatus == 'FINISH' ? [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Incorporation/Transfer Time"
    }
  }, [_c('el-date-picker', {
    staticClass: "fluid-width",
    attrs: {
      "type": "date",
      "placeholder": "Incorporation/Transfer Time",
      "value-format": "yyyy-MM-dd 00:00:00"
    },
    model: {
      value: _vm.dataForm.incorporateTime,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "incorporateTime", $$v);
      },
      expression: "dataForm.incorporateTime"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Renewal Time"
    }
  }, [_c('el-date-picker', {
    staticClass: "fluid-width",
    attrs: {
      "type": "date",
      "placeholder": "Renewal Time",
      "value-format": "yyyy-MM-dd 00:00:00"
    },
    model: {
      value: _vm.dataForm.renewalTime,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "renewalTime", $$v);
      },
      expression: "dataForm.renewalTime"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Information Items",
      "prop": "companyInfoList"
    }
  }, [_c('div', {
    staticClass: "addBtnWrap"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.addHandle
    }
  }, [_vm._v("Add Item")])], 1), _c('div', {
    staticClass: "itemListWrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Client Code")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 12
    }
  }, [_vm._v("Company/Fund Manager Name")]), _c('el-col', {
    staticClass: "itemTitle",
    attrs: {
      "span": 5
    }
  }, [_vm._v("Biz Reg. No. (UEN)")])], 1), _vm._l(_vm.dataForm.companyInfoList, function (ele, index) {
    return _c('div', {
      key: "category-".concat(index),
      staticClass: "wdb100"
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "companyInfoList.".concat(index, ".clientCode")
      }
    }, [_c('client-code-select-remote-search', {
      attrs: {
        "showItems": ['companyName', 'uen'],
        "placeholder": "Client Code"
      },
      on: {
        "change-item": function changeItem(data) {
          return _vm.clientCodeChange(data, ele);
        }
      },
      model: {
        value: ele.clientCode,
        callback: function callback($$v) {
          _vm.$set(ele, "clientCode", $$v);
        },
        expression: "ele.clientCode"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "companyInfoList.".concat(index, ".companyName"),
        "rules": {
          required: _vm.dataRule.companyInfoList ? true : false,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "regexFilter",
        rawName: "v-regexFilter",
        value: _vm.halfWidthRegex,
        expression: "halfWidthRegex"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "Company/Fund Manager Name"
      },
      model: {
        value: ele.companyName,
        callback: function callback($$v) {
          _vm.$set(ele, "companyName", $$v);
        },
        expression: "ele.companyName"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "companyInfoList.".concat(index, ".uen"),
        "rules": {
          required: _vm.dataRule.companyInfoList ? true : false,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "clearable": "",
        "placeholder": "Biz Reg. No. (UEN)"
      },
      model: {
        value: ele.uen,
        callback: function callback($$v) {
          _vm.$set(ele, "uen", $$v);
        },
        expression: "ele.uen"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "icon": "el-icon-delete",
        "plain": ""
      },
      on: {
        "click": function click($event) {
          return _vm.deleteHandle(index);
        }
      }
    })], 1)], 1)], 1);
  })], 2)])], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Article of Association"
    }
  }, [_c('div', {
    staticClass: "bgWrap"
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.articlesOfIncorporationUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "articlesOfIncorporationUrls", $$v);
      },
      expression: "dataForm.articlesOfIncorporationUrls"
    }
  })], 1)])], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Biz/Gov File"
    }
  }, [_c('div', {
    staticClass: "bgWrap"
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.businessDocumentsUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessDocumentsUrls", $$v);
      },
      expression: "dataForm.businessDocumentsUrls"
    }
  })], 1)])], 1), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Other Documents",
      "prop": "otherDocumentsUrls"
    }
  }, [_c('div', {
    staticClass: "bgWrap"
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.otherDocumentsUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "otherDocumentsUrls", $$v);
      },
      expression: "dataForm.otherDocumentsUrls"
    }
  })], 1)])], 1)] : _vm._e()], 2)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "loading": _vm.saveLoading,
      "disabled": _vm.submitLoading
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit(true);
      }
    }
  }, [_vm._v("Save")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading,
      "disabled": _vm.saveLoading
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit(false);
      }
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }